(function () {
  function initM10(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-m10-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-m10-panel]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-m10-dot]'));
    var prev = root.querySelector('[data-m10-prev]');
    var next = root.querySelector('[data-m10-next]');

    if (!tabs.length || tabs.length !== panels.length) {
      return;
    }

    var activeIndex = Math.max(0, tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }));

    function labelFor(index) {
      return tabs[index] ? tabs[index].textContent.trim() : 'category';
    }

    function setActive(index, shouldFocus) {
      activeIndex = (index + tabs.length) % tabs.length;

      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === activeIndex;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel, panelIndex) {
        var active = panelIndex === activeIndex;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === activeIndex;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (prev) {
        prev.setAttribute('aria-label', 'Show ' + labelFor(activeIndex - 1 < 0 ? tabs.length - 1 : activeIndex - 1));
      }
      if (next) {
        next.setAttribute('aria-label', 'Show ' + labelFor((activeIndex + 1) % tabs.length));
      }
      if (shouldFocus && tabs[activeIndex]) {
        tabs[activeIndex].focus();
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setActive(index, false);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(activeIndex + 1, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(activeIndex - 1, true);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          setActive(0, true);
        }
        if (event.key === 'End') {
          event.preventDefault();
          setActive(tabs.length - 1, true);
        }
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setActive(index, false);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        setActive(activeIndex - 1, false);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        setActive(activeIndex + 1, false);
      });
    }

    setActive(activeIndex, false);
  }

  function boot() {
    document.querySelectorAll('[data-avelere-m10]').forEach(initM10);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
